<script lang="ts" setup>
import { useSessionExpiry } from '@/composables/useSessionExpiry'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
const { secondsRemaining, isMasked, showCountdown, extendSession } = useSessionExpiry()

const formattedTime = computed(() => {
  const s = Math.max(0, secondsRemaining.value)
  const mins = Math.floor(s / 60)
  const secs = s % 60

  return `${mins}:${String(secs).padStart(2, '0')}`
})

const isExtending = ref(false)

async function handleExtend() {
  isExtending.value = true
  try {
    await extendSession()
  } finally {
    isExtending.value = false
  }
}
</script>

<template>
  <!--
    Idle screen mask (VH-3676). Fullscreen and opaque, not a translucent blur, so
    no patient information shows through on an unattended screen; VDialog also
    traps focus so the page behind can't be tabbed into.
  -->
  <VDialog
    :model-value="isMasked"
    fullscreen
    persistent
    transition="none"
  >
    <VCard class="d-flex align-center justify-center">
      <div
        class="text-center pa-6"
        style="max-inline-size: 460px;"
      >
        <h2 class="text-h6 font-weight-bold mb-2">
          Are you still there?
        </h2>
        <p class="text-body-2 mb-6">
          <template v-if="showCountdown">
            You'll be logged out due to inactivity in <strong>{{ formattedTime }}</strong>.
          </template>
          <template v-else>
            Your screen is hidden to protect patient information while you're away.
          </template>
        </p>
        <div class="d-flex justify-center gap-3">
          <VBtn
            variant="text"
            @click="auth.logout()"
          >
            Log out
          </VBtn>
          <VBtn
            :loading="isExtending"
            @click="handleExtend"
          >
            Continue
          </VBtn>
        </div>
      </div>
    </VCard>
  </VDialog>
</template>
